module.exports = __webpack_public_path__ + "static/media/hero-banner-md.34f7d65a.jpg";